module.exports = __webpack_public_path__ + "static/media/clouds-moon.c168b4c2.svg";